/**
 * Sanitizer a URL parameter to avoid XSS vulnerabilities.
 * This method will block javascript in URL parameter as a security precaution
 * @param url
 */
import { __values } from "tslib";
var unsafeProtocols = [
    '^.*[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:.*',
    '^.*[\u0000-\u001F ]*d[\r\n\t]*a[\r\n\t]*t[\r\n\t]*a[\r\n\t]*:.*', //data
];
export function sanitizeUrlParameter(url) {
    var e_1, _a;
    if (url) {
        try {
            for (var unsafeProtocols_1 = __values(unsafeProtocols), unsafeProtocols_1_1 = unsafeProtocols_1.next(); !unsafeProtocols_1_1.done; unsafeProtocols_1_1 = unsafeProtocols_1.next()) {
                var unsafeProtocol = unsafeProtocols_1_1.value;
                var unsafeProtocolRegex = new RegExp(unsafeProtocol);
                var match = url.match(unsafeProtocolRegex);
                if (match) {
                    var sanitizedUrl = url.replace(unsafeProtocolRegex, '');
                    return sanitizedUrl;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (unsafeProtocols_1_1 && !unsafeProtocols_1_1.done && (_a = unsafeProtocols_1.return)) _a.call(unsafeProtocols_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return url;
}
//# sourceMappingURL=sanitizeUrlParameter.js.map